module.exports = __webpack_public_path__ + "static/media/welcome.8577663f.jpg";